import { gql } from "@stadium/services/apollo-client";

export const fetchStoreAuthBasedParams = gql`
  query Store($number: String) {
    store(number: $number) {
      id
      designedStoreIds: storeIds
    }
  }
`;

export const fetchUserDesignedStoreConfig = gql`
  query fetchUserDesignedStoreConfig {
    user {
      id
      lockerSwagList(type: "myself") {
        id: storeId
      }
      onDemandSwagList(type: "myself") {
        id: storeId
      }
      allLockerSwagList: lockerSwagList {
        id: storeId
      }
      allOnDemandSwagList: onDemandSwagList {
        id: storeId
      }
    }
  }
`;
